__turbopack_context__.v({
  "accountLinks": "public-site-module__1SOrda__accountLinks",
  "brand": "public-site-module__1SOrda__brand",
  "desktopAccount": "public-site-module__1SOrda__desktopAccount",
  "desktopLanguage": "public-site-module__1SOrda__desktopLanguage",
  "desktopNav": "public-site-module__1SOrda__desktopNav",
  "footer": "public-site-module__1SOrda__footer",
  "footerBottom": "public-site-module__1SOrda__footerBottom",
  "footerColumns": "public-site-module__1SOrda__footerColumns",
  "footerInvitation": "public-site-module__1SOrda__footerInvitation",
  "footerStory": "public-site-module__1SOrda__footerStory",
  "footerTop": "public-site-module__1SOrda__footerTop",
  "footerWordmark": "public-site-module__1SOrda__footerWordmark",
  "header": "public-site-module__1SOrda__header",
  "headerCta": "public-site-module__1SOrda__headerCta",
  "headerInner": "public-site-module__1SOrda__headerInner",
  "headerSource": "public-site-module__1SOrda__headerSource",
  "headerTools": "public-site-module__1SOrda__headerTools",
  "loginLink": "public-site-module__1SOrda__loginLink",
  "menu-enter": "public-site-module__1SOrda__menu-enter",
  "menu-link-enter": "public-site-module__1SOrda__menu-link-enter",
  "menuBrand": "public-site-module__1SOrda__menuBrand",
  "menuClose": "public-site-module__1SOrda__menuClose",
  "menuToggle": "public-site-module__1SOrda__menuToggle",
  "menuTop": "public-site-module__1SOrda__menuTop",
  "mobileAccount": "public-site-module__1SOrda__mobileAccount",
  "mobileExtras": "public-site-module__1SOrda__mobileExtras",
  "mobileLanguage": "public-site-module__1SOrda__mobileLanguage",
  "mobileMenu": "public-site-module__1SOrda__mobileMenu",
  "mobileNav": "public-site-module__1SOrda__mobileNav",
  "noScriptNav": "public-site-module__1SOrda__noScriptNav",
  "reading-progress": "public-site-module__1SOrda__reading-progress",
  "readingBar": "public-site-module__1SOrda__readingBar",
  "site": "public-site-module__1SOrda__site",
  "themeControl": "public-site-module__1SOrda__themeControl",
});
